import AuthContext from 'context/authContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import paths from 'routes/paths';
import BeneficiaryForm from './beneficiary-form/BeneficiaryForm';
import { useCreateBeneficiary } from 'hooks/useBeneficiaries';
import { clearDraft } from './beneficiary-form/beneficiaryDraft';
import { createJuzProgress } from 'lib/supabaseQueries';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

function CreateBeneficiary() {
  const navigate = useNavigate();

  const { organization, selectedBranchId, user } = useContext(AuthContext);

  const { createBeneficiaryAsync, isCreating: loading } =
    useCreateBeneficiary();

  const onSubmit = async ({ initial_juz, ...data }) => {
    try {
      // createBeneficiary saves the guardian itself (and links it); creating
      // one here as well left a second, unlinked guardian row per child
      const result = await createBeneficiaryAsync({
        ...data,
        created_by_user_id: user?.id || null
      });

      // Hafiz students: the Juz given on the form becomes the first progress
      // entry. The child is already saved, so a failure here only warns.
      const created = result?.data;
      if (initial_juz && created?.id) {
        const { error } = await createJuzProgress({
          orphan_id: created.id,
          organisation_id: organization?.id,
          branch_id: created.branch_id || selectedBranchId || null,
          juz: initial_juz,
          recorded_on: format(new Date(), 'yyyy-MM-dd'),
          notes: 'Recorded when the profile was created',
          recorded_by: user?.id || null
        });
        if (error) {
          toast.warning(
            'The child was saved but the Juz could not be recorded. Add it from the profile.'
          );
        }
      }

      clearDraft(user?.id);
      navigate(paths.beneficiaries);
    } catch (err) {
      console.error('Error creating beneficiary:', err);
    }
  };

  return <BeneficiaryForm onSubmit={onSubmit} loading={loading} />;
}

export default CreateBeneficiary;
